<template>
    <div>
        <b-tabs card>
            <b-tab title="LIST LOCATIONS">
                <ListLocations />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import ListLocations from '@/components/Locations/ListLocations'

    export default {
        name: "LocationsMain",
        components: {ListLocations},
        data: function(){
            return {}
        },
        methods: {},
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            if (this.packet.userDetails.userrole != 'admin'){
                localStorage.clear()
                this.$router.push("/")
            }
        }

    }

</script>

<style scoped>
   
</style>


// WEBPACK FOOTER //
// src/components/Locations/LocationsMain.vue